/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import PermissionTabContent from './PermissionTabContent';

interface IMenuData {
    menuId: number;
    roleId: number;
    sortOrder: number;
    isDisplay: boolean;
    menuName: string;
    menuFeaturePermissions: MenuFeaturePermission[];
  }
  
interface MenuFeaturePermission {
    menuFeatureId: number;
    menuFeature: string;
    hasPermission: boolean;
  }

interface SelectedMenuId {
    menuFeatureId: number;
  }

interface PermissionTabProps {
    page: string;
    menuData: IMenuData[];
    closeModal: () => void; 
    onMenuFeatureSelect: (menuFeatureId: any, checked: boolean) => void;
    selectedMenuFeatureIds: number[];
    setSelectedMenuFeatureIds: React.Dispatch<React.SetStateAction<number[]>>;
}

function PermissionTab({menuData, onMenuFeatureSelect, selectedMenuFeatureIds, setSelectedMenuFeatureIds }: PermissionTabProps):JSX.Element {
    const [selectedMenuIds, setSelectedMenuIds] = useState<SelectedMenuId[]>([]);

    useEffect(() => {
        const ids: any = [];
        const mainMenuId: any = []
        console.log("selectedMenuFeatureIds===X", selectedMenuFeatureIds)
        
        if(selectedMenuFeatureIds.length === 0) {
            menuData.forEach(menu => {
                let hasPermissionLength = 0;
                menu.menuFeaturePermissions.forEach(permission => {
                    
                    if (permission.hasPermission) {
                        hasPermissionLength++
                        ids.push({ menuFeatureId: permission.menuFeatureId });
                    }
                });
                if(menu.menuFeaturePermissions.length === hasPermissionLength) {
                    mainMenuId.push({ menuFeatureId: menu.menuId })
                }
            });
            console.log("selectedMenuFeatureIds===Y", ids)
            setSelectedMenuIds(mainMenuId)
            setSelectedMenuFeatureIds(ids);
        } 
        else {
            const selectedIds: any = [];
            selectedMenuFeatureIds.map((id: any) => {
                
                if(id.menuFeatureId) {
                    selectedIds.push(id.menuFeatureId)
                } else {
                    selectedIds.push(id)
                }
                
            })
            menuData.forEach(menu => {
                let hasPermissionLength = 0;
                menu.menuFeaturePermissions.forEach(permission => {
                    
                    if (selectedIds.includes(permission.menuFeatureId)) {
                        hasPermissionLength++
                        ids.push({ menuFeatureId: permission.menuFeatureId });
                    }
                });
                if(menu.menuFeaturePermissions.length === hasPermissionLength) {
                    mainMenuId.push({ menuFeatureId: menu.menuId })
                }
            });
            setSelectedMenuIds(mainMenuId)
            setSelectedMenuFeatureIds(ids);
        } 
        
    }, [menuData]);

    const onItemSelect = (menuObj: SelectedMenuId, checked: boolean, menuType: string): void => {
      
        if (checked) {
            if (menuType === "main") {
                setSelectedMenuIds([...selectedMenuIds, menuObj]);
                const subMenuIds = menuData
                    .filter(item => item.menuId === menuObj.menuFeatureId)
                    .flatMap(item => item.menuFeaturePermissions.map(subItem => subItem.menuFeatureId));
                setSelectedMenuFeatureIds([...selectedMenuFeatureIds, ...subMenuIds]);

                
                onMenuFeatureSelect(subMenuIds, checked);
            }
            if (menuType === "sub") {
                setSelectedMenuFeatureIds([...selectedMenuFeatureIds, menuObj.menuFeatureId]);
                onMenuFeatureSelect([menuObj.menuFeatureId], checked);
            }
        } else {
            if (menuType === "main") {
                // setSelectedMenuIds(prevState => prevState.filter(item => item.menuFeatureId !== menuObj.menuFeatureId));
                const a = selectedMenuIds.filter(item => item.menuFeatureId !== menuObj.menuFeatureId)
                setSelectedMenuIds(a);

                // const data = menuData.filter(item => item.menuId === menuObj.menuFeatureId);

                // let selectedIds1:any = []
                // data[0].menuFeaturePermissions.map(item => {
                //     console.log("menuData===x", item)
                //     selectedIds1.push(item.menuFeatureId)
                    
                // })
                
                

                // setSelectedMenuFeatureIds(selectedIds)

                const subMenuIds = menuData
                    .filter(item => item.menuId === menuObj.menuFeatureId)
                    .flatMap(item => item.menuFeaturePermissions.map(subItem => subItem.menuFeatureId));
                const selectedIds: any = [];
                selectedMenuFeatureIds.map((id: any) => {
                    
                    if(id.menuFeatureId && !subMenuIds.includes(id.menuFeatureId)) {
                        selectedIds.push(id.menuFeatureId)
                    } else if(!id.menuFeatureId && !subMenuIds.includes(id)) {
                        selectedIds.push(id)
                    }
                    
                })
                setSelectedMenuFeatureIds(selectedIds);
                // onMenuFeatureSelect(selectedIds, checked);
            }
            if (menuType === "sub") {
                setSelectedMenuFeatureIds(selectedMenuFeatureIds.filter(id => id !== menuObj.menuFeatureId));
            }
        }
       
    };

    return (
        <div>
            <div className='px-[16px] pt-[10px] mb-[60px]'>
                {menuData.map((menu:any, index:number) => {
                    return (
                    <PermissionTabContent
                        key={index}
                        menuData={menu}
                        index={index}
                        onItemSelect={(menuObj, checked, menuType) => onItemSelect(menuObj, checked, menuType)}
                        selected={selectedMenuIds.some(item => item.menuFeatureId === menu.menuId)}
                        selectedMenuFeatureIds={selectedMenuFeatureIds}
                    />
                )
                })}
            </div>
            {/* <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" onClick={() => handleSave()}>{LABEL_BTN_SAVE}</button>
                </div>
            </div> */}
        </div>
    );
}

export default PermissionTab;
